import _get from "lodash/get";
import React from 'react';
import classnames from 'classnames';
import { StickyContainer } from 'react-sticky-modified';
import { HEADER_SEARCH_RESULTS } from 'swag-client-common/utils/constants';
import { ALL_SWAG_CATEGORY } from 'swag-client-common/constants';
import { isMobile } from 'swag-client-common/utils/ui.utils';
import { variables } from 'swag-client-common/styles/css-variables-helper';
import Page from '../../../page';
import { ProductsSorting } from '../product-listing/components/products-sorting';
import { Filters } from '../../../popups/filters-popup';
import FilterControllers from '../filter-controllers';
import { MobileSearchProductListingActiveFiltersRow } from '../../../page/components/header/components/filters-row-panel';
import { PostalPanel } from '../product-listing/components/postal-panel';
import classes from './search-results.scss';
import FilterItem from './components/filter-item';
import InfiniteProducts from './components/infinite-products';
const SearchResults = ({
  productListing: {
    currentCategoryName
  },
  query,
  total,
  lastPage,
  page,
  isProductsListFetched,
  sorting,
  getProducts,
  isActiveFilterBlockShown,
  onOpenFilterPanel,
  onCloseFilterPanel,
  isLoading,
  isFilterPopupOpen,
  productAttributes,
  categories,
  colorFamily,
  pricing,
  productionTime,
  minQuantity,
  embellishmentMethod,
  boxAndInventory,
  maxPrintColors,
  imprintLocationsAmount,
  sortProducts,
  changeIsShownMobMenuState,
  currentCategory
}) => {
  const [sortingIsOpen, setSortingIsOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(undefined);
  const openSorting = e => {
    e.preventDefault();
    setSortingIsOpen(true);
    setAnchorEl(e.currentTarget);
  };
  const handleSortProducts = (e, v) => {
    sortProducts({
      sorting: v
    });
    setSortingIsOpen(false);
  };
  const closeSorting = () => {
    setSortingIsOpen(false);
  };
  const openCategories = () => {
    changeIsShownMobMenuState(true);
  };
  const isAllSwag = currentCategoryName === ALL_SWAG_CATEGORY;
  const isEmptyCategory = _get(currentCategory, ['subcategories', 'length']) === 0;
  const mobileView = isMobile();
  const isViolet = true;
  const anchorOrigin = {
    horizontal: mobileView && 'middle' || 'left',
    vertical: mobileView && 'bottom' || 'top'
  };
  const targetOrigin = {
    horizontal: mobileView && 'middle' || 'right',
    vertical: mobileView && 'top' || 'top'
  };
  return /*#__PURE__*/React.createElement(StickyContainer, null, /*#__PURE__*/React.createElement(Page, {
    withPurpleWave: !isLoading && total === 0,
    header: HEADER_SEARCH_RESULTS,
    headerIsSticky: true,
    headerIsViolet: isViolet,
    regularBrowseProductsLink: true,
    isAdviceBannerShow: page === lastPage && isProductsListFetched
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.categories, {
      [classes.minHeightWhileLoading]: isLoading
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.separatorStyle, {
      [classes.thinSeparator]: isFilterPopupOpen,
      [classes.allSwag]: isAllSwag || isEmptyCategory,
      [classes.activeFiltersSeparator]: isActiveFilterBlockShown
    })
  }), /*#__PURE__*/React.createElement(FilterControllers, {
    isFilterPopupOpen: isFilterPopupOpen,
    onOpenCategories: openCategories,
    onOpenFilterPanel: onOpenFilterPanel,
    onOpenSorting: openSorting
  }), /*#__PURE__*/React.createElement(PostalPanel, {
    isFilterPopupOpen: isFilterPopupOpen,
    isSortingOpen: sortingIsOpen,
    onOpenFilterPanel: onOpenFilterPanel,
    onCloseFilterPanel: onCloseFilterPanel,
    onOpenSorting: openSorting
  }), /*#__PURE__*/React.createElement(MobileSearchProductListingActiveFiltersRow, {
    isFilterPopupOpen: isFilterPopupOpen
  }), /*#__PURE__*/React.createElement(Filters, {
    imprintLocationsAmount: imprintLocationsAmount,
    maxPrintColors: maxPrintColors,
    embellishmentMethod: embellishmentMethod,
    boxAndInventory: boxAndInventory,
    minQuantity: minQuantity,
    productionTime: productionTime,
    colorFamily: colorFamily,
    categories: categories,
    productAttributes: productAttributes,
    onOpen: onOpenFilterPanel,
    onClose: onCloseFilterPanel,
    isOpen: isFilterPopupOpen,
    FilterItemComponent: FilterItem,
    pricing: pricing,
    isLoading: isLoading,
    secondaryColor: variables.secondary,
    primaryColor: variables.primary
  }), /*#__PURE__*/React.createElement(InfiniteProducts, {
    total: total,
    query: query,
    getProducts: getProducts,
    isFilterApplied: isActiveFilterBlockShown,
    isFilterPopupOpen: isFilterPopupOpen
  }), /*#__PURE__*/React.createElement(ProductsSorting, {
    sorting: sorting,
    anchorEl: anchorEl,
    isOpen: sortingIsOpen,
    anchorOrigin: anchorOrigin,
    targetOrigin: targetOrigin,
    openSorting: openSorting,
    closeSorting: closeSorting,
    sortProducts: handleSortProducts,
    primaryColor: variables.primary,
    secondaryColor: variables.secondary
  })))));
};
export default SearchResults;